export { type WordDefinition, wordDefinitionTable } from "#word-definition-table";
